import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
})
export class ColorPickerComponent {
  @Input() lines = 'none';
  @Input() includePreview: boolean = false;
  @Input() label = 'COLOR';
  @Input() value = "#000";
  @Output() selectedColor = new EventEmitter<string>();

  constructor() {}

  selectColor(event) {
    this.selectedColor.emit(event.target.value);
  }
}
